// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1cNWB","disabled":"FileBtn_disabled__1WkPU","warn":"FileBtn_warn__2CqHv","fade":"FileBtn_fade__10p5v"};